import React from 'react';
import { S9_RAO } from '../t04-dala-orbit/t04LandingShared';

export const T05_TRUST_FACTS = [
  'EU-Server Frankfurt',
  'Self-Hosted',
  `${S9_RAO} · Verschwiegenheit`,
  'Ein Login',
] as const;

/**
 * Eine Spur muss breiter sein als das Fenster. Sonst schiebt translateX(-50%)
 * die zweite Kopie aus dem Bild und rechts bleibt eine Lücke, bis die Animation springt.
 */
const LOOP_COPIES = 8;

const TrustSet: React.FC<{ facts: readonly string[]; hidden?: boolean }> = ({ facts, hidden }) => (
  <div className={hidden ? 't05-trust-strip__set t05-trust-strip__loop-copy' : 't05-trust-strip__set'} aria-hidden={hidden || undefined}>
    {Array.from({ length: LOOP_COPIES }, (_, copy) =>
      facts.map((fact) => (
        <span
          key={`${copy}-${fact}`}
          className={copy > 0 ? 't05-trust-strip__item t05-trust-strip__repeat' : 't05-trust-strip__item'}
          aria-hidden={copy > 0 || undefined}
        >
          <span className="t05-trust-strip__dot" aria-hidden />
          {fact}
        </span>
      )),
    )}
  </div>
);

export const T05TrustMarquee: React.FC<{
  facts?: readonly string[];
  label?: string;
}> = ({ facts = T05_TRUST_FACTS, label = 'Vertrauensmerkmale' }) => {
  return (
    <section className="t05-trust-strip t05-trust-strip--marquee reveal-up" aria-label={label}>
      <div className="t05-trust-strip__row">
        <TrustSet facts={facts} />
        <TrustSet facts={facts} hidden />
      </div>
    </section>
  );
};
